var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.329,
    height: 26.885,
    viewBox: "0 0 29.329 26.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_716526",
    transform: "translate(0 -17.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(4.888 21.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 4.888,
    height: 2.444,
    fill: "#f2813b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 17.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M26.885,26.845H24.441V19.512A2.452,2.452,0,0,0,22,17.068H2.444A2.452,2.452,0,0,0,0,19.512V31.733a2.452,2.452,0,0,0,2.444,2.444H4.888v7.332a2.452,2.452,0,0,0,2.444,2.444H26.885a2.452,2.452,0,0,0,2.444-2.444V29.289A2.452,2.452,0,0,0,26.885,26.845ZM24.85,29.289l-7.741,6.967L9.366,29.289H24.85Zm-19.962,0v2.444H2.444V19.512H22v7.332H7.332A2.452,2.452,0,0,0,4.888,29.289Zm2.444,12.22V30.746L16.2,38.727a1.391,1.391,0,0,0,1.816,0l8.868-7.982V41.509H7.332Z",
    transform: "translate(0 -17.068)",
    fill: "#f2813b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage3);
export default __webpack_public_path__ + "static/media/usage-3.53a937c5e1367911b2d876839f22e69c.svg";
export { ForwardRef as ReactComponent };